module.exports = __webpack_public_path__ + "static/media/first_declension_imperf_alpha_img.80c54093.JPG";